<template>
  <div class="outer">
    <div class="rank banner">
      <el-row :gutter="20">
        <el-col :sm="24" :md="8">
          <img src="../../assets/images/Massager/5.jpg" width="100%" height="200px" alt="">
        </el-col>
        <el-col :sm="24" :md="7">
          <img src="../../assets/images/Massager/6.jpg" width="100%" height="200px" alt="">
        </el-col>
        <el-col :sm="24" :md="8">
          <img src="../../assets/images/Massager/1.png" width="100%" height="200px" alt="">
        </el-col>
      </el-row>
    </div>
    <div class="rank ">
      <div class="flex items-center borderbottom">
        <div class="flashSale">Let's help you find something</div>
      </div>
      <div class="content">
        <ul>
          <li style="flex-wrap: wrap">
            <el-row :gutter="0">
              <el-col :xs="12" :sm="6" :md="6" :lg="6" v-for="item in homeListLike" :key="item.id"
                class="img-item img-item2">
                <div @click="gotoProduct(item, $event)" class="tab-pic shadow">
                  <a href="#">
                    <img style="width:100%;height:100%;" :src="item.homeImg" />
                  </a>
                  <div style="width:100%" class="info-title ellipsis">
                    <a href="#">{{ item.obj1.title }}</a>
                  </div>
                  <div style="width:100%;padding-bottom: 8px;" class="info-price">{{ item.obj1.money }} $</div>
                </div>
              </el-col>
            </el-row>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { homeList } from '@/json/home1.js';
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  name: 'home',
  data() {
    return {
      catList: homeList.slice(16, 25),
      homeListLike: homeList.slice(0, 25)
    };
  },
  components: {},
  methods: {
    gotoProduct(val, e) {
      console.log(val, e);
      this.$router.replace({
        path: '/product',
        query: {
          row: val
        }
      })
      e.stopPropagation()
      e.preventDefault()
    },
  },
  mounted() {
    new Swiper(".swiper-container", {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}
</script>
<style lang="less" scoped>
.swiper-container {
  --swiper-navigation-color: #ede9f0;
  --swiper-navigation-size: 20px;
}

.list-outer {
  position: absolute;

  img {
    width: 100%;
  }
}

.banner-title {
  position: absolute;
  top: 30%;
  left: 5%;

  .p1 {
    font-size: 40px;
    font-weight: bold;
  }

  .p2 {
    font-size: 24px;
  }
}

.fontImgSize {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 16px;
}

.outer .rank .content {
  padding: 0;
}

.img-item2 {
  border-radius: 12px;
  padding: 18px 10px !important
}

// .outer .rank .content ul li {
//   justify-content: unset;
// }

.banner {
  padding: 16px 10px 0;
}

.banner img {
  border-radius: 12px;
  display: block;
  margin-bottom: 18px;
  object-fit: cover;
}

.info-title {
  padding: 0 48px;
}

.outer .rank .content ul li .img-item .tab-pic {
  text-align: center;
}

.outer .rank .content ul li .info-price {
  text-align: center;
}

.outer .rank .content ul li .img-item .tab-pic a img {
  width: 240px !important;
  height: 270px !important;
}

@media (width < 768px) {
  .outer .rank .content ul li .img-item .tab-pic a img {
    width: 160px !important;
    height: 160px !important;
  }

  .info-title {
    padding: 0;
  }
}
</style>